<template>
    <div class="container" v-loading="repLoading">

        <div v-if="!showInner">
            <div class="flex_space_between search_box">
                <div class="flex_start">
                    <div class="flex_start_center mr_24">
                        <div class="mr_12">患者姓名：</div>
                        <div>
                            <el-input placeholder="请输入" v-model="searchForm.name"></el-input>
                        </div>
                    </div>
                    <div class="custom_btn primary_btn" @click="search">搜索</div>
                    <div class="custom_btn warning_btn" @click="reset">重置</div>
                </div>

                <div class="add_btn" @click="getberNumber(),showHzList = true">
                    新增患者
                </div>
            </div>

            <div class="huanz_list" v-if="list.length != 0" :image-size="200">
                <div :class="`item ${key % 4 == 0 ? 'item_l' : ''}`" v-for="(val, key) in list" :key="key">
                    <div :class="`item_title ${val.bind == 1 ? '' : 'item_title_red'}`" class="flex_space_between">
                        <div class="num">{{ val.bed_number }}</div>
                        <div class="flex_start" style="gap:10px">
                             <div class="report_btn" @click="openHzly(val)">患者离院</div>
                            <!-- <div class="report_btn" @click="handleSleepReport(val)" v-show="val.bind == 1">睡眠报告</div> -->
                            <div class="report_btn" @click="handleActivityDialog(val)" v-show="val.bind == 1">活动统计</div>
                        </div>
                    </div>
                    <div class="item_box">
                         <el-tooltip class="item" effect="dark" :content="val.name" placement="top" v-if="val.name && val.name.length > 7">
                                <div class="item_name">{{ val.name }}</div>
                        </el-tooltip>
                         <div class="item_name" v-else>{{ val.name || "" }}</div>
                        <div class="item_btn" v-if="val.bind == 1" @click="yibindVisiblebor(val)">
                            设备已绑定
                        </div>
                        <div class="item_btn red" @click="bindVisiblebor(val)" v-else>
                            设备未绑定
                        </div>
                    </div>
                </div>
            </div>

            <el-empty v-if="list.length == 0" description="暂无数据" style="margin-top: 5%;"></el-empty>
            <el-dialog :visible.sync="bindVisible" title="绑定设备" width="1200px" class="el_dialog">
                <div class="_bindList">
                    <el-table :data="bindList" v-loading="repLoading" align="center" border>
                        <el-table-column prop="ccid" label="设备CCID号" align="center"></el-table-column>
                        <el-table-column prop="status" label="状态" align="center">
                            <template slot-scope="scope">
                                <div :class="`_bindList_text${scope.row.bind}`">
                                    {{ scope.row.bind == 1 ? '已绑定' : '未绑定' }}
                                    {{ scope.row.bind == 1 ? `（${scope.row.bed_number}床）` : '' }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="160">
                            <template slot-scope="scope">
                                <el-button type="info" size="large" v-if="scope.row.bind == 1" disabled
                                    color="#9296AF">已绑定</el-button>
                                <el-button type="primary" size="large" v-else
                                    @click="patient_bind(scope.row)">绑定</el-button>

                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>

            <el-dialog :visible.sync="setConfigDialog" v-loading="figsLoading" :title="configDisabledTitle"
                width="1200px" class="el_dialog">
                <div class="set_config_box">
                    <el-form :model="configSetForm" v-loading="figsLoading" :disabled="configDisabled"
                        :rules="configSetFormRules" ref="configSetForm" class="config_set_form" label-width="180px"
                        label-position="left">
                        <div class="config_type_title">心率预警阈值</div>
                        <el-form-item prop="high_heartrate_value" label="最高值（bpm）：">
                            <el-input size="mini" class="el_input" placeholder="请输入"
                                v-model="configSetForm.high_heartrate_value"></el-input>
                            <span style="margin:0 5px 0 40px;">持续</span>
                            <el-select placeholder="请选择" v-model="configSetForm.high_heartrate_time" size="mini"
                                class="el_input">
                                <el-option label="立即" :value="1" v-if="affter == '2'"></el-option>
                                <el-option label="10分钟" :value="10"></el-option>
                                <el-option label="20分钟" :value="20"></el-option>
                                <el-option label="30分钟" :value="30"></el-option>
                            </el-select>
                            <span style="margin:0 5px;">高心率预警</span>
                        </el-form-item>
                        <el-form-item prop="low_heartrate_value" label="最低值（bpm）：">
                            <el-input size="mini" class="el_input" placeholder="请输入"
                                v-model="configSetForm.low_heartrate_value"></el-input>
                            <span style="margin:0 5px 0 40px;">持续</span>
                            <el-select placeholder="请选择" v-model="configSetForm.low_heartrate_time" size="mini"
                                class="el_input">
                                <el-option label="立即" :value="1" v-if="affter == '2'"></el-option>
                                <el-option label="10分钟" :value="10"></el-option>
                                <el-option label="20分钟" :value="20"></el-option>
                                <el-option label="30分钟" :value="30"></el-option>
                            </el-select>
                            <span style="margin:0 5px;">低心率预警</span>
                        </el-form-item>
                        <div class="config_type_title mt_20">血氧预警阈值</div>
                        <el-form-item prop="spo2" label="最低值（%）：">
                            <el-input size="mini" class="el_input" placeholder="请输入"
                                v-model="configSetForm.spo2"></el-input>
                            <span style="margin:0 5px 0 40px;">持续</span>
                            <el-select placeholder="请选择" v-model="configSetForm.low_spo_time" size="mini"
                                class="el_input">
                                <el-option label="立即" :value="1" v-if="affter == '2'"></el-option>
                                <el-option label="10分钟" :value="10"></el-option>
                                <el-option label="20分钟" :value="20"></el-option>
                                <el-option label="30分钟" :value="30"></el-option>
                            </el-select>
                            <span style="margin:0 5px;">低血氧预警</span>
                        </el-form-item>
                        <div class="config_type_title mt_20">数据频率设置</div>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item prop="ppg" label="采集频率：" label-width="auto">
                                    <div class="el_input">{{ uploadfrequency }}</div>
<!--                                     
                                    <el-select placeholder="请选择" v-model="configSetForm.ppg" size="mini"
                                        class="el_input_2">
                                        <el-option v-for="(item, index) in ppg_list" :key="index" :label="item.label"
                                            :value="item.value"></el-option>
                                    </el-select> -->
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="normal_rate" label="上传频率：" label-width="auto">
                                    <el-select placeholder="请选择" v-model="configSetForm.normal_rate" size="mini"
                                        class="el_input_2" v-if="configSetForm.ppg == 300">
                                        <el-option v-for="(item, index) in normal_rate_list_1" :key="index"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                    <el-select placeholder="请选择" v-model="configSetForm.normal_rate" size="mini" v-else
                                        class="el_input_2">
                                        <el-option v-for="(item, index) in normal_rate_list_2" :key="index"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <span slot="footer" v-if="!configDisabled" class="dialog-footer">
                    <div class="config_tips">设置阈值后，{{ configSetForm.ppg / 60 * configSetForm.normal_rate }}分钟后生效</div>
                    <!-- <el-button type="info" @click="setConfigDialog = false">取 消</el-button> -->
                    <!-- <el-button type="primary" @click="confirmSetConfig">确 定</el-button> -->
                    <div class="flex_center_center">
                        <div class="custom_btn info_btn" @click="setConfigDialog = false">取 消</div>
                        <div class="custom_btn primary_btn" @click="confirmSetConfig">确 定</div>
                    </div>
                </span>
                <span slot="footer" v-else class="dialog-footer">
                    <div class="config_tips">设置阈值后，{{ configSetForm.ppg / 60 * configSetForm.normal_rate }}分钟后生效</div>
                    <!-- <el-button type="primary" @click="confirmConfig">更换阈值</el-button> -->
                    <!-- <el-button type="danger" @click="unbindDevice">解绑</el-button> -->
                    <div class="flex_center_center">
                        <div class="custom_btn primary_btn" @click="confirmConfig">更换阈值</div>
                        <div class="custom_btn danger_btn" @click="unbindDevice">解 绑</div>
                    </div>
                </span>
            </el-dialog>

            <el-dialog :visible.sync="tipsDialog" v-loading="figsLoading" title="设备解绑" width="580px" class="el_dialog">
                <div class="_tips">
                    <i class="el-icon-warning el-icon-iconName " color="#e6a23c"></i><span>是否将该设备进行解绑</span>
                </div>
                <span slot="footer" class="dialog-footer">
                    <!-- <el-button type="info" @click="tipsDialog = false">取 消</el-button>
                <el-button type="primary" @click="setTipsDialog">确 定</el-button> -->
                    <div class="flex_center_center">
                        <div class="custom_btn info_btn" @click="tipsDialog = false">取 消</div>
                        <div class="custom_btn primary_btn" @click="setTipsDialog">确 定</div>
                    </div>
                </span>
            </el-dialog>
            <!-- <ActivityDialog :dialogVisible="showActivityDialog" :dialogData="patientInfo" @closeDialog="closeActiveDialog">
        </ActivityDialog> -->

            <SleepDialog :dialogVisible="showSleepDialog" :dialogData="patientInfo" @closeDialog="closeSleepDialog">
            </SleepDialog>
        </div>
        <ActivityInner v-else :patientInfo="patientInfo" @handleBackBtn="handleBackBtnFn"></ActivityInner>



        <el-dialog :visible.sync="showHzList"  title="新增患者" class="el_dialog add_hz_list" width="580px" @close="resetForm('ruleForm')">
          <el-form :model="ruleForm" :rules="addhzrules" ref="ruleForm" label-width="100px" class="ruleForm" v-loading="submitLoading">
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="ruleForm.name" placeholder="请输入姓名" maxLength="20" class="width_300"></el-input>
                        </el-form-item>
                        <el-form-item label="性别" prop="sex">
                            <el-select v-model="ruleForm.sex" placeholder="请选择性别"  class="width_300">
                            <el-option label="男" value="1"></el-option>
                            <el-option label="女" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                          <el-form-item label="床位" prop="bed_id">
                            <el-select v-model="ruleForm.bed_id" placeholder="请选择床位"  class="width_300">
                                
                            <el-option :label="item.bed_number" :value="item.id" v-for="(item, index) in bedList" :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>

                         <el-form-item label="住院号" prop="num">
                            <el-input v-model="ruleForm.num" placeholder="请输入住院号" maxLength="50"  class="width_300"></el-input>
                        </el-form-item>

                        <el-form-item>
                            <div class="width_300 flex_between">
                                <el-button @click="resetForm('ruleForm')" class="cancel_btn">取消</el-button>
                                <el-button type="primary" @click="submitForm('ruleForm')" class="confirm_btn">确认</el-button>
                            </div>
                        </el-form-item>

                        </el-form>

                    <!-- <span slot="footer" class="dialog-footer">
                        <div class="footer_btn">
                            <el-button @click="resetForm('ruleForm')" class="cancel_btn">取消</el-button>
                            <el-button type="primary" @click="submitForm('ruleForm')" class="confirm_btn">确认</el-button>
                        </div>
                </span> -->
        </el-dialog>


        <el-dialog :visible.sync="hzlyDialog"  title="患者离院" width="580px" class="el_dialog">
                <div class="hz_tips" v-loading="hzlyLoading">
                      是否将该患者转为离院?
                </div>
                <span slot="footer" class="dialog-footer">
                    <!-- <el-button type="info" @click="tipsDialog = false">取 消</el-button>
                <el-button type="primary" @click="setTipsDialog">确 定</el-button> -->
                    <div class="flex_center_center">
                        <el-button class="cancel_btn" @click="hzlyDialog = false">取 消</el-button>
                        <el-button type="primary" class="confirm_btn" @click="confirmHzLY">确 定</el-button>
                    </div>
                </span>
        </el-dialog>
    </div>
</template>

<script>
const checkLow = (rule, value, callback) => {
    setTimeout(() => {
        if (!Number.isInteger(Number(value))) {
            callback(new Error("请输入范围在30-60之间的整数"));
        } else {
            if (value < 30 || value > 60) {
                callback(new Error("请输入范围在30-60之间的整数"));
            } else {
                callback();
            }
        }
    }, 300);
};
const checkHigh = (rule, value, callback) => {
    setTimeout(() => {
        if (!Number.isInteger(Number(value))) {
            console.log(value);
            callback(new Error("请输入范围在80-160之间的整数"));
        } else {
            if (value < 80 || value > 160) {
                callback(new Error("请输入范围在80-160之间的整数"));
            } else {
                callback();
            }
        }
    }, 300);
};
const checkSpo2 = (rule, value, callback) => {
    setTimeout(() => {
        if (!Number.isInteger(Number(value))) {
            callback(new Error("请输入范围在70-99之间的整数"));
        } else {
            if (value < 70 || value > 99) {
                callback(new Error("请输入范围在70-99之间的整数"));
            } else {
                callback();
            }
        }
    }, 300);
};
// import ActivityDialog from './components/activityDialog.vue';
import ActivityInner from './components/activity_inner.vue';

import SleepDialog from './components/sleepDialog.vue';
export default {
    data() {
        return {
            hzlyDialog:false,
hzlyLoading:false,
            bedList:[],
            submitLoading:false,
            showHzList:false, // 显示新增患者弹窗
            ruleForm:{
                name: '',
                sex: '',
                bed_id: '',
                num: ''
            },
           addhzrules: {
            name: [
                { required: true, message: '请输入患者姓名', trigger: 'blur' },
                { min: 1, max: 20, message: '长度为 1 到 20 个字符', trigger: 'blur' }
            ],
            bed_id: [
                { required: true, message: '请选择床位号', trigger: 'change' }
            ],
            num: [
                { required: true, message: '请输入住院号', trigger: 'blur' }
            ]
          },
            affter: '',
            showInner: false,
            searchForm: {
                name: '',
            },
            list: [],
            zone_number: '',
            bindVisible: false,
            bindList: [],
            itemData: '',
            repLoading: false,
            configSetForm: {
                high_heartrate_value: 130,
                high_heartrate_time: 10,
                low_heartrate_value: 40,
                low_heartrate_time: 10,
                spo2: 90,
                low_spo_time: 10,
                ppg: 600,
                normal_rate: 6,
            },
            configSetFormRules: {
                high_heartrate_value: [
                    { required: true, message: "请输入心率预警最高值", trigger: "blur" },
                    { validator: checkHigh, trigger: "blur" },
                ],
                low_heartrate_value: [
                    { required: true, message: "请输入心率预警最低值", trigger: "blur" },
                    { validator: checkLow, trigger: "blur" },
                ],
                spo2: [
                    { required: true, message: "请输入血氧预警最低值", trigger: "blur" },
                    { validator: checkSpo2, trigger: "blur" },
                ],
                ppg: [{ required: true, message: "请选择采集频率", trigger: "blur" }],
                normal_rate: [
                    { required: true, message: "请选择上传频率", trigger: "blur" },
                ],
            },
            setConfigDialog: false,
            ppg_list: [
                {
                    label: "5分钟",
                    value: 300,
                },
                {
                    label: "10分钟",
                    value: 600,
                },
            ],
            normal_rate_list_1: [
                {
                    label: "10分钟",
                    value: 2,
                },
                {
                    label: "15分钟",
                    value: 3,
                },
                {
                    label: "20分钟",
                    value: 4,
                },
                {
                    label: "25分钟",
                    value: 5,
                },
                {
                    label: "30分钟",
                    value: 6,
                },
            ],
            normal_rate_list_2: [
                {
                    label: "20分钟",
                    value: 2,
                },
                {
                    label: "30分钟",
                    value: 3,
                },
                {
                    label: "40分钟",
                    value: 4,
                },
                {
                    label: "50分钟",
                    value: 5,
                },
                {
                    label: "60分钟",
                    value: 6,
                },
            ],
            configDisabled: true,
            configDisabledTitle: '设备信息',
            tipsDialog: false,
            figsLoading: false,
            patientInfo: {},
            showActivityDialog: false,
            patientInfoData:false,
            showSleepDialog: false
        }
    },
    computed:{
        uploadfrequency(){
            let index = this.ppg_list.findIndex(item => item.value == this.configSetForm.ppg);
            if(index>=0){
                    return this.ppg_list[index].label
            }else{
                return "10分钟"
            }
        }
    },
    mounted() {
        this.zone_number = localStorage.getItem("zone_number");
        this.affter = localStorage.getItem('affter')
        this.patient_list();
        this.getberNumber();
        this.checkLogin()
    },
    methods: {
        // 
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                let index = this.bedList.findIndex(item => item.id === this.ruleForm.bed_id);
                let data = {
                    name: this.ruleForm.name,
                    sex:this.ruleForm.sex,
                    bed_id:this.ruleForm.bed_id,
                    bed_number: index > -1 ? this.bedList[index].bed_number : '',
                    patient_number: this.ruleForm.num,
                    zone_number:this.zone_number,
                    room_number:"9999"
                }
                this.submitLoading = true
                this.$http({
                    url: "/api/patient/add",
                    method: "post",
                    params: data,
                    headers: {
                        Token: localStorage.getItem("token"),
                    },
                }).then((res) => {
                    this.$message.success('操作成功');
                    this.patient_list();
                    this. resetForm(formName);
                    this.submitLoading = false
                }).catch(err => {
                    this.submitLoading = false
                })
            } else {
                console.log('error submit!!');
                return false;
            }
            });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.showHzList = false;
      },
        checkLogin() {
            console.log(!localStorage.getItem("token"));
            if (!localStorage.getItem("token")) {
                this.$router.push("/login");
            }
        },
        patient_list() {

            let data = {
                zone_number: this.zone_number,
                name: this.searchForm.name
            }
            this.repLoading = true
            this.$http({
                url: "/api/patient/list",
                method: "GET",
                params: data,
                headers: {
                    Token: localStorage.getItem("token"),
                },
            }).then((res) => {
                console.log('res:', res)
                this.list = res.result;
                this.repLoading = false
            }).catch(err => {
                this.repLoading = false
            })
        },
        getberNumber(){
              let data = {
                zone_number: this.zone_number
            }
            this.$http({
                url: "/api/bed/list",
                method: "post",
                params: data,
                headers: {
                    Token: localStorage.getItem("token"),
                },
            }).then((res) => {
                this.bedList = res.result;
            }).catch(err => {
            })
        },
        search() {
            this.patient_list();
        },
        reset() {
            this.searchForm = {
                name: '',
            }
            this.patient_list();
        },
        bindVisiblebor(item) {
            this.bindList = [];
            this.bindVisible = true;
            this.itemData = item
            this.bind_list();
        },
        //设备绑定列表
        bind_list() {
            this.repLoading = true;
            let data = {
                zone_number: this.zone_number,
            }
            this.$http({
                url: "/api/patient/bind_list",
                method: "GET",
                params: data,
                headers: {
                    Token: localStorage.getItem("token"),
                },
            }).then((res) => {
                console.log('res:', res)
                this.bindList = res.result;
                this.repLoading = false
            }).catch(err => {
                this.repLoading = false
            })
        },
        //绑定
        patient_bind(row) {
            this.repLoading = true;
            let data = {
                zone_number: this.zone_number,
                id: row.id,
                patient_id: this.itemData.patient_id,
                bed_number: this.itemData.bed_number,
            }
            this.$http({
                url: "/api/patient/bind",
                method: "POST",
                data: data,
                headers: {
                    Token: localStorage.getItem("token"),
                },
            }).then((res) => {
                console.log('res:', res)
                this.$message.success('操作成功')
                this.repLoading = false
                this.bindVisible = false
                this.patient_list()
            }).catch(err => {
                this.repLoading = false
                this.bindVisible = false
                this.patient_list()
            })
        },
        yibindVisiblebor(item) {
            this.setConfigDialog = true;
            this.configDisabled = true;
            this.yiitemData = item;
            this.configDisabledTitle = '设备信息'
            this.figsLoading = true;
            //设备信息
            this.$http({
                url: "/api/patient/device",
                method: "GET",
                params: {
                    zone_number: this.zone_number,
                    ccid: item.ccid
                },
                headers: {
                    Token: localStorage.getItem("token"),
                },
            }).then((res) => {
                console.log(res)
                this.configSetForm = res.result
                this.configSetForm.ppg = Number(res.result.ppg)
                this.figsLoading = false;
            }).catch(err => {
                this.setConfigDialog = false;
                this.figsLoading = false;

            })
        },
        confirmConfig() {
            this.configDisabled = false;
            this.configDisabledTitle = '更换阈值'
        },
        //更换阈值
        confirmSetConfig() {
            this.figsLoading = true;
            this.$refs.configSetForm.validate((valid) => {
                if (valid) {
                    let data = Object.assign(
                        { zone_number: this.zone_number },
                        this.configSetForm
                    );
                    console.log('data', data)
                    this.$http({
                        url: "/api/patient/set_config",
                        method: "POST",
                        data: data,
                        headers: {
                            Token: localStorage.getItem("token"),
                            // 'Content-Type':"multipart/form-data"
                        },
                    }).then((res) => {
                        this.$message.success("修改成功");
                        this.setConfigDialog = false;
                        this.figsLoading = false;
                    }).catch(() => {
                        this.setConfigDialog = false;
                        this.figsLoading = false;
                    });
                }
            });
        },
        setTipsDialog() {
            // v-loading="figsLoading"
            this.figsLoading = true;
            let item = this.yiitemData;
            let data = {
                zone_number: this.zone_number,
                patient_id: item.patient_id,
                bed_number: item.bed_number,
            };
            console.log('data', data)
            this.$http({
                url: "/api/patient/out_bind",
                method: "POST",
                data: data,
                headers: {
                    Token: localStorage.getItem("token"),
                },
            }).then((res) => {
                this.$message.success("解绑成功");
                this.tipsDialog = false
                this.figsLoading = false;
                this.patient_list();

            });
        },
        confirmHzLY(){
             this.hzlyLoading = true;
            let item = this.patientInfoData;
            let data = {
                zone_number: this.zone_number,
                patient_id: item.patient_id,
                bed_number: item.bed_number,
            };
            this.$http({
                url: "/api/patient/out_hp",
                method: "POST",
                data: data,
                headers: {
                    Token: localStorage.getItem("token"),
                },
            }).then((res) => {
                this.$message.success("操作成功");
                this.hzlyLoading = false
                this.hzlyDialog = false;
                this.patient_list();

            }).finally(() => {
                this.hzlyLoading = false
            });

        },
        unbindDevice() {

            this.tipsDialog = true;
            this.setConfigDialog = false;

            // this.$confirm("此操作将解绑该设备, 是否继续?", "提示", {
            //     confirmButtonText: "确定",
            //     cancelButtonText: "取消",
            //     type: "warning",
            // })
            //     .then(() => {

            //     })
            //     .catch(() => {
            //         this.$message({
            //             type: "info",
            //             message: "已取消操作",
            //         });
            //     });
        },
        openHzly(item){
            this.hzlyDialog = true;
            this.patientInfoData = item;
        },
        handleActivityDialog(patientInfo) {
            this.patientInfo = patientInfo;
            this.showInner = true;
        },
        handleBackBtnFn() {
            this.showInner = false
        },
        closeActiveDialog() {
            this.showActivityDialog = false;
        },
        handleSleepReport(patientInfo) {
            this.patientInfo = patientInfo;
            this.showSleepDialog = true;
        },
        closeSleepDialog() {
            this.showSleepDialog = false;
        }
    },
    components: {
        ActivityInner, SleepDialog
    }
}
</script>

<style scoped>
@import url('../../assets/style/commo.css');
.add_btn{
    width: fit-content;
    padding: 10px 20px;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #c7c7c7;
    color: #000000;
    font-size: 18px;
    cursor: pointer;
}
.add_btn:hover{
    opacity: .8;
}
.huanz_list {
    display: flex;
    flex-wrap: wrap;
}
.ruleForm{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-right: 30px;
}
.width_300{
    width: 320px;
}

.footer_btn{
    padding: 0px 100px;
    /* padding-left: ; */
    display: flex;
    justify-content: space-around;
}
.cancel_btn,.confirm_btn{
     width: 130px;
     height: 40px;
     text-align: center;
     cursor: pointer;
}
.cancel_btn{
 background-color: #c7c7c7;
      color: #000000;
}
.cancel_btn:active{
    border: none;
}



.item {
    width: 24%;
    height: 228px;
    border-radius: 12px;
    overflow: hidden;
    margin-left: 1.3%;
    margin-bottom: 24px;
}

.huanz_list .item_l {
    margin-left: 0%;
}

.item .item_title {
    background-color: #EAF4FF;
    height: 56px;
    line-height: 56px;
    padding-left: 23px;
    padding-right: 23px;
    font-size: 24px;
    color: #252B50;
    font-family: 'SourceHanSansCN-Bold';
    font-weight: bold;
    /* width: 373px; */
}
.flex_between{
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
}

.item_title_red {
    background-color: #FFECE6 !important;
}

.item_box {
    background-color: white;
    height: calc(100% - 56px);
    /* width: 373px; */
    text-align: center;
    padding-top: 20px;
}

.item_name {
    width:100%;
    font-size: 48px;
    height: 48px;
    font-weight: bold;
    font-family: 'SourceHanSansCN-Bold';
    margin-bottom: 20px;
    line-height: 48px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.item_btn {
    background-color: #3889FF;
    border-radius: 52px;
    width: 138px;
    height: 52px;
    line-height: 52px;
    margin: auto;
    color: #fff;
    cursor: pointer;
    font-size: 18px;
    font-family: 'SourceHanSansCN-Medium';
}

.huanz_list .red {
    background-color: #E24040;

}

._bindList {
    height: 540px;
    overflow-y: scroll;
}

._bindList_text1 {
    color: #3889FF;
}

._bindList_text2 {
    color: #E24040;
}

.set_config_box>>>.el_input {
    width: 140px;
}

.config_type_title {
    color: #252b50;
    font-weight: bold;
    margin-bottom: 12px;
}

.mt_20 {
    margin-top: 20px;
}

.config_tips {
    color: #e24040;
    margin-bottom: 16px;
    font-size: 16px;
}

.set_config_box {
    font-size: 16px;
    padding: 0 24px;
}
.hz_tips{
      height: 146px;
    line-height: 146px;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

._tips {
    height: 146px;
    line-height: 146px;
    color: #e6a23c;
    display: flex;
    align-items: center;
    justify-content: center;
}

._tips span {
    color: #636676;
    margin-left: 5px;
}

.el-icon-iconName {
    font-size: 20px;
}


.set_config_box {
    font-size: 18px;
    padding: 0 24px;
}

.config_type_title {
    color: #252b50;
    font-weight: bold;
    margin-bottom: 12px;
}

.mt_20 {
    margin-top: 20px;
}

.set_config_box>>>.el_input {
    width: 364px;
}

.el_input_2 {
    width: 430px;
}

.report_btn {
    border: 1px solid #3889FF;
    border-radius: 24px 24px 24px 24px;
    width: 80px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3889FF;
    font-size: 14px;
    font-family: 'Source Han Sans CN-Bold';
    cursor: pointer;
}
>>> .add_hz_list .el-dialog__body{
   padding-bottom: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/huanz_list.vue